import { InlineAlert } from '@design-systems/canvas-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLogClick } from 'utils/analytics'
import './banner-alert.scss'

interface BannerAlertProps {
    className?: string
    heading?: string
    storageKey: string
    linkUrl?: string
    linkText?: string
    children: React.ReactNode
}

export const BannerAlert: React.FC<BannerAlertProps> = ({
    storageKey,
    className = 'banner-alert',
    heading = 'Attention',
    linkUrl,
    linkText,
    children,
}) => {
    const { t } = useTranslation()
    const { logClick } = useLogClick('banner')
    const [visible, setVisible] = useState(() => {
        if (typeof window === 'undefined') return true
        return localStorage.getItem(storageKey) !== 'true'
    })

    if (!visible) return null

    const isExternalLink = linkUrl?.startsWith('http')

    return (
        <InlineAlert
            variant="info"
            heading={heading}
            className={className}
            onClose={() => {
                setVisible(false)
                localStorage.setItem(storageKey, 'true')
            }}
            data-testid="banner-alert"
            role="status"
        >
            {children}
            {linkUrl?.trim() && linkText?.trim() && (
                <>
                    {' '}
                    <a
                        href={linkUrl}
                        className="banner-alert__link"
                        onClick={() => logClick(`banner link: ${linkUrl}`)}
                        {...(isExternalLink && {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                        })}
                    >
                        {linkText}
                        {isExternalLink && (
                            <span className="hc8-sr-only">
                                {` (${t('banner.opensNewTab')})`}
                            </span>
                        )}
                    </a>
                </>
            )}
        </InlineAlert>
    )
}
